import React, { useEffect, useState } from 'react';
import { IconButton, Table } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { FaPen } from 'react-icons/fa';
import { useStoreActions, useStoreState } from '../../store/hooks';
import toPagedRequest from '../../services/pagedRequestService';
import { PaginationScreenKey } from '../../services/paginationLimitService';
import useStorePagination from '../../hooks/storePaginationHook';
import { PricingDataListItem } from '../../api/apiTypes';
import pricingColumns from './PricingColumns';
import PricingMarginsEditModal from './Margins/PricingMarginsEditModal';
import Pagination from '../Pagination';

function PricingDataTable() {
  const { fetchPricingData, setFilter } = useStoreActions(actions => actions.pricingData);
  const {
    pricingData, loading, currentFilter, total,
  } = useStoreState(state => state.pricingData);
  const { limit, changePage, changeLimit } = useStorePagination(
    PaginationScreenKey.PRICING_DATA,
    currentFilter,
    setFilter,
    50,
  );
  const [marginsItem, setMarginsItem] = useState<PricingDataListItem | null>(null);

  function handleEditMargins(item: PricingDataListItem) {
    setMarginsItem(item);
  }

  function handleMarginsClosed() {
    setMarginsItem(null);
  }

  function handleMarginsSaved() {
    setMarginsItem(null);
    fetchPricingData({
      request: toPagedRequest(currentFilter, limit),
    });
  }

  useEffect(() => {
    if (currentFilter.filter.marketplaceCodes && currentFilter.filter.marketplaceCodes.length > 0) {
      fetchPricingData({
        request: toPagedRequest(currentFilter, limit),
      });
    }
  }, [currentFilter, limit]);

  return (
    <div className="h100p">
      <Table
        fillHeight
        bordered
        data={pricingData}
        loading={loading}
      >
        <Table.Column width={80} align="center" fixed key="actions">
          <Table.HeaderCell>Actions</Table.HeaderCell>
          <Table.Cell style={{ padding: 8 }}>
            {(rowData) => (
              <IconButton
                size="xs"
                appearance="subtle"
                title="Edit margins"
                icon={<Icon as={FaPen} />}
                onClick={() => handleEditMargins(rowData as PricingDataListItem)}
              />
            )}
          </Table.Cell>
        </Table.Column>

        {pricingColumns}
      </Table>

      <div className="mt-10">
        <Pagination
          total={total}
          limit={limit}
          activePage={currentFilter.page}
          onChangePage={changePage}
          onChangeLimit={changeLimit}
        />
      </div>

      {marginsItem && (
        <PricingMarginsEditModal
          isOpen
          marketplaceCode={marginsItem.marketplaceCode ?? ''}
          partnerProductCode={marginsItem.sku ?? ''}
          onClose={() => handleMarginsClosed()}
          onSaved={() => handleMarginsSaved()}
        />
      )}
    </div>
  );
}

export default React.memo(PricingDataTable);
